@file:OptIn(kotlin.uuid.ExperimentalUuidApi::class)

package com.yogaaicoach.pages.workoutresults

import com.yogaaicoach.common.ui.components.StarsIcon
import com.yogaaicoach.common.ui.components.TopBar
import com.yogaaicoach.scope
import com.yogaaicoach.user.AppViewModel
import kotlinx.coroutines.launch
import react.FC
import react.Props
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.h1
import react.dom.html.ReactHTML.h2
import react.dom.html.ReactHTML.p
import react.useEffectOnce
import react.useState
import web.cssom.ClassName
import kotlin.uuid.Uuid

internal external interface WorkoutResultsPageProps : Props {
    var viewModel: WorkoutResultsViewModel
    var appViewModel: AppViewModel
    var workoutGuid: String
    var onNavigateToDashboard: () -> Unit
    var onNavigateToPayment: () -> Unit
    var onNavigateToContactUs: () -> Unit
}

private val difficultyLabels = listOf("Very Easy", "Easy", "Just Right", "Difficult", "Very Difficult")

internal val WorkoutResultsPage = FC<WorkoutResultsPageProps> { props ->
    var selectedDifficulty by useState<Int?>(null)

    useEffectOnce {
        scope.launch { props.viewModel.selectedDifficulty.collect { selectedDifficulty = it } }
    }

    val workoutGuid = props.workoutGuid.takeIf { it.isNotEmpty() }?.let { Uuid.parse(it) }

    div {
        className = ClassName("workout-results-page")

        TopBar {
            title = "Training Results"
            onSignOut = { props.appViewModel.signOut() }
            onNavigateToDashboard = props.onNavigateToDashboard
            onNavigateToPayment = props.onNavigateToPayment
            onNavigateToContactUs = props.onNavigateToContactUs
        }

        div {
            className = ClassName("workout-results-scroll")

            div {
                className = ClassName("workout-results-content")

                div {
                    className = ClassName("workout-results-hero")
                    div { className = ClassName("workout-results-icon-wrapper"); StarsIcon {} }
                    h1 { className = ClassName("workout-results-title"); +"Training Completed!" }
                    p { className = ClassName("workout-results-subtitle"); +"Good job!" }
                }

                div {
                    className = ClassName("workout-results-rating")
                    h2 { className = ClassName("workout-results-question"); +"How difficult was the workout?" }

                    difficultyLabels.forEachIndexed { index, label ->
                        val value = index + 1
                        button {
                            className = ClassName(
                                if (selectedDifficulty == value) "workout-difficulty-btn workout-difficulty-btn-selected"
                                else "workout-difficulty-btn"
                            )
                            onClick = { props.viewModel.updateSelectedDifficulty(value) }
                            +label
                        }
                    }
                }
            }
        }

        // Footer sits outside the scroll container so the CTA is always visible at the
        // bottom of the viewport on mobile without needing position:fixed.
        div {
            className = ClassName("workout-results-footer")
            button {
                className = ClassName("primary-button")
                onClick = {
                    if (workoutGuid != null) {
                        props.viewModel.onFinishWorkoutClick(workoutGuid) { props.onNavigateToDashboard() }
                    } else {
                        props.onNavigateToDashboard()
                    }
                }
                +"Finish Workout"
            }
        }
    }
}
